<app-credit-tier-structures
  [creditStructures]="creditStructures$ | async"
  [creditStructureGroups]="creditStructureGroups$ | async"
  (tierChange)="tierChange.emit()"
  (creditStructureCheckChange)="onCreditStructureCheckChange($event)"
  (creditStructureGroupSelectionChange)="onCreditStructureGroupSelectionChange($event)"
></app-credit-tier-structures>
